<template>
	<div class="w-full overflow-hidden h-full flex flex-wrap relative">
		<div ref="zoomed-bounds" class="relative overflow-hidden h-full z-20 w-full">
			<div ref="zoomed-svg-container" class="w-full h-full relative overflow-hidden">
				<img ref="zoomed-svg" :src="image" class="object-cover block w-full h-full" />
			</div>
		</div>
		<div class="flex flex-col absolute right-0 bottom-0 z-20">
			<div @click="setZoom('out')" class="cursor-pointer mb-2">
				<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="36" height="36" fill="white"/>
					<line x1="10.667" y1="18.3167" x2="26.667" y2="18.3167" stroke="black" stroke-width="0.7"/>
					<line x1="19.017" y1="10.6667" x2="19.017" y2="26.6667" stroke="black" stroke-width="0.7"/>
				</svg>
			</div>
			<div @click="setZoom('in')" >
				<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="36" height="36" fill="white"/>
					<line x1="10.6665" y1="18.3166" x2="26.6665" y2="18.3166" stroke="black" stroke-width="0.7"/>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
import { gsap, Power3 } from 'gsap';
import { Draggable } from 'gsap/Draggable';

export default {
	name: "draggable-image",
	props: {
		image: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			zoomed: false,
			scale: 1,
		}
	},
	components: {
	},
	methods: {
		setZoom(type) {
			const results = this.zoomSvg(
					type,
					this.$refs['zoomed-svg-container'],
					this.$refs['zoomed-svg'],
					this.scale
			);

			this.scale = results.scale;
			this.zoomed = results.zoomed;
		},
		handleZoom(scale = false, attr = {}, target = false) {
			if (!target) {
				return;
			}
			const config = {
				force3D: true,
				ease: Power3.easeInOut,
				duration: 0.5,
				attr,
			};
			if (scale) {
				config.scale = scale;
			}
			gsap.to(target, config);
		},
		zoomSvg(type, svgContainer, svg, scale) {
			let zoomed = false;
			let scaleTo;

			if (type === 'out') {
				scaleTo = scale + 1;
			} else {
				scaleTo = scale - 1;
			}

			if (scaleTo >= 1 && scaleTo <= 5) {
				this.handleZoom(scaleTo, {}, svgContainer);
				zoomed = scale > 1;
			}

			if (scaleTo === 1) {
				zoomed = false;
				this.handleZoom(false, { style: 'transform: translate3d(0px, 0px, 0px);' }, svg);
			}

			if (scaleTo > 5) {
				scaleTo = 5;
			} else if (scaleTo < 1) {
				scaleTo = 1;
			}

			return {
				scale: scaleTo,
				zoomed,
			};
		},
		setDraggable(target, bounds) {
			Draggable.create(target, {
				force3D: true,
				type: 'x, y',
				dragClickables: true,
				edgeResistance: 0.65,
				autoScroll: true,
				bounds,
			});
		}
	},
	mounted() {
		this.$nextTick(() => {
			gsap.registerPlugin(Draggable);
			this.setDraggable(this.$refs['zoomed-svg'], this.$refs['zoomed-bounds']);
		})
	}
}
</script>

<style scoped>

</style>
